module.exports = __webpack_public_path__ + "static/img/Pegi45.b3db0c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bank-logos-45/Pegi45.png
// module id = 9ZlC
// module chunks = 6